import {
  CIVILBUDGETMATERIAL_LOADING,
  GET_CIVILBUDGETMATERIAL,
  GET_CIVILBUDGETMATERIAL_SUCCESS,
  GET_CIVILBUDGETMATERIAL_FAIL,
  ADD_CIVILBUDGETMATERIAL_SUCCESS,
  ADD_CIVILBUDGETMATERIAL_FAIL,
  DELETE_CIVILBUDGETMATERIAL_SUCCESS,
  DELETE_CIVILBUDGETMATERIAL_FAIL,
  UPDATE_CIVILBUDGETMATERIAL_SUCCESS,
  UPDATE_CIVILBUDGETMATERIAL_FAIL,
  CIVILBUDGETMATERIAL_RESET
} from "./actionType";

const INIT_STATE = {
  civilBudgetMaterials: [],
  error: {},
};

const CivilBudgetMaterial = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_CIVILBUDGETMATERIAL_SUCCESS:
      switch (action.payload.actionType) {
        case GET_CIVILBUDGETMATERIAL:
          return {
            ...state,
            civilBudgetMaterials: action.payload.data,
            isCivilBudgetMaterialCreated: false,
            isCivilBudgetMaterialSuccess: true,
            loading: false,
          };

        default:
          return { ...state };
      }
    case GET_CIVILBUDGETMATERIAL_FAIL:
      switch (action.payload.actionType) {
        case GET_CIVILBUDGETMATERIAL_FAIL:
          return {
            ...state,
            error: action.payload.error,
            isCivilBudgetMaterialCreated: false,
            isCivilBudgetMaterialSuccess: false,
            loading: false,
          };
        default:
          return { ...state };
      }

    case GET_CIVILBUDGETMATERIAL: {
      return {
        ...state,
        isCivilBudgetMaterialCreated: false,
        loading: true,
      };
    }

    case CIVILBUDGETMATERIAL_LOADING: {
      return {
        ...state,
        isCivilBudgetMaterialCreated: false,
        loading: true,
      };
    }

    case ADD_CIVILBUDGETMATERIAL_SUCCESS:
      return {
        ...state,
        isCivilBudgetMaterialCreated: true,
        loading: false,
        // civilBudgetMaterials: [...state.civilBudgetMaterials, action.payload.data],
      };

    case ADD_CIVILBUDGETMATERIAL_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_CIVILBUDGETMATERIAL_SUCCESS:
      return {
        ...state,
        isCivilBudgetMaterialCreated: true,
        loading: false,
        // civilBudgetMaterials: state.civilBudgetMaterials.filter(
        //   civilCivilBudgetMaterial => civilCivilBudgetMaterial.id.toString() !== action.payload.id.toString()
        // ),
      };

    case DELETE_CIVILBUDGETMATERIAL_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_CIVILBUDGETMATERIAL_SUCCESS:
      return {
        ...state,
        isCivilBudgetMaterialCreated: true,
        loading: false,
        // civilBudgetMaterials: state.civilBudgetMaterials.map(civilCivilBudgetMaterial =>
        //   civilCivilBudgetMaterial.id.toString() === action.payload.data.id.toString() ? { ...civilCivilBudgetMaterial, ...action.payload.data } : civilCivilBudgetMaterial
        // ),
      };

    case UPDATE_CIVILBUDGETMATERIAL_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case CIVILBUDGETMATERIAL_RESET:
      return INIT_STATE;

    default:
      return { ...state };
  }
};

export default CivilBudgetMaterial;